import './styles.scss';
import redIdentity from '../../assets/red-identity.png';


function Symptoms() {

    return (
        <div className="container-symptoms">
            <div className='symptoms-content'>
                <h1>Você sente isso?</h1>
                <ul>
                    <li><i className="fa-solid fa-angles-right"></i>Dor ou sensação de peso nas pernas ao fim do dia?</li>
                    <li><i className="fa-solid fa-angles-right"></i>Vasinhos que incomodam esteticamente?</li>
                    <li><i className="fa-solid fa-angles-right"></i>Inchaço nos pés e nas pernas?</li>
                    <li><i className="fa-solid fa-angles-right"></i>Medo de que as varizes piorem com o tempo?</li>
                </ul>
                <p>Se respondeu sim para alguma dessas perguntas, seu corpo está pedindo cuidado. E esse cuidado pode começar agora.</p>

                <a href="https://wa.me/5571997303062" target="_blank" rel="noopener noreferrer">Quero iniciar meu tratamento</a>
                <img className="symptoms-identity" src={redIdentity} alt="DLM" />

            </div>
        </div>

    );
}

export default Symptoms;
